import { AudienceResponseDTO } from 'src/modules/audiences/infra/dtos';

import { FormikSelect } from '@/components/forms';
import { SelectItem } from '@/design-system/components/ui';

interface AudienceSelectFieldProps {
  audiences: AudienceResponseDTO[];
  disabled?: boolean;
}

export default function AudienceSelectField({ audiences, disabled }: AudienceSelectFieldProps) {
  return (
    <FormikSelect
      name="audienceId"
      label="Audience (optional)"
      placeholder="Default (all users)"
      disabled={disabled}
      parseValue={(val) => (val === '__none__' ? null : val)}
    >
      <SelectItem value="__none__">Default (all users)</SelectItem>
      {audiences.map((audience) => (
        <SelectItem key={audience.id} value={audience.id}>
          {audience.name}
        </SelectItem>
      ))}
    </FormikSelect>
  );
}
